import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setOperatorSkillOperations = (state, { operatorSkillOperationsData }) => {
  if (!operatorSkillOperationsData) return state;
  return state.merge({ operatorSkillOperationsData });
};

const setOperatorSkillOperationsLoaderStatus = (state, { operatorSkillOperationsLoader }) => {
  return state.merge({ operatorSkillOperationsLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_OPERATOR_SKILL_OPERATIONS,
    actionFunction: setOperatorSkillOperations,
  },
  {
    actionType: ActionTypes.SET_OPERATOR_SKILL_OPERATIONS_LOADER_STATUS,
    actionFunction: setOperatorSkillOperationsLoaderStatus,
  },
];
